import { connect } from 'react-redux'
import AssessementInvitationModal from './assessment-invitation-modal'
import { errorHandler } from 'pobble-components/dist/error-handler'
import {
  closeInvitationAssessmentDialog,
  inviteToAssessmentFile,
  fetchAssessmentFileInviteesCounter
} from '../../../stores/assessment-file/assessment-file.actions'
import {
  isInvitationModalOpen,
  getAssessmentFileId,
  getFetchInvitationRequest
} from '../../../stores/assessment-file/assessment-file.selectors'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = state => {
  return {
    isOpen: isInvitationModalOpen(state),
    id: getAssessmentFileId(state),
    pending: getFetchInvitationRequest(state).pending
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  requestClose: () => dispatch(closeInvitationAssessmentDialog()),
  onSubmit: (emails, token, message) =>
    dispatch(
      inviteToAssessmentFile(
        stateProps.id,
        emails.map(email => email.value),
        token,
        message
      )
    )
      .then(() => {
        toast.success('Your invitation was sent.')
        dispatch(fetchAssessmentFileInviteesCounter(stateProps.id))
        return dispatch(closeInvitationAssessmentDialog())
      })
      .catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AssessementInvitationModal)
